import { render, staticRenderFns } from "./removePost.vue?vue&type=template&id=672fe843&scoped=true&lang=pug"
import script from "./removePost.vue?vue&type=script&lang=js"
export * from "./removePost.vue?vue&type=script&lang=js"
import style0 from "./removePost.vue?vue&type=style&index=0&id=672fe843&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672fe843",
  null
  
)

export default component.exports